var BxfBadgeTypeEnum;
(function (BxfBadgeTypeEnum) {
    BxfBadgeTypeEnum["NUMBER"] = "number";
    BxfBadgeTypeEnum["TEXT"] = "text";
    BxfBadgeTypeEnum["ICON"] = "icon";
    BxfBadgeTypeEnum["TEXT_WITH_ICON"] = "text_with_icon";
    BxfBadgeTypeEnum["CUSTOM"] = "custom";
})(BxfBadgeTypeEnum || (BxfBadgeTypeEnum = {}));

export { BxfBadgeTypeEnum as B };
